"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDnd = require("react-dnd");

var _VideoProjectCard = _interopRequireDefault(require("../components/VideoProjectCard"));

var _optionalDrag = _interopRequireDefault(require("../../../utils/optionalDrag"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var DRAG_TYPE = 'box';

function beginDrag(project) {
  return project;
}

function endDrag(project, monitor) {
  var dropResult = monitor.getDropResult();

  if (dropResult) {
    var onProjectDrop = dropResult.onProjectDrop,
        videoFolderId = dropResult.videoFolderId;
    onProjectDrop(project, videoFolderId);
  }
}

function getDragConfig(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  };
}

var dragHandlers = {
  beginDrag: beginDrag,
  endDrag: endDrag
};
var dragSource = (0, _reactDnd.DragSource)(DRAG_TYPE, dragHandlers, getDragConfig);

function VideoProjectCard(gotoProject, canDrag, folders) {
  var VideoProjectCardWithDrag = (0, _optionalDrag.default)(_VideoProjectCard.default, dragSource, canDrag);
  return function (props) {
    return (/*#__PURE__*/_react.default.createElement(VideoProjectCardWithDrag, _extends({
        folders: folders,
        gotoProject: gotoProject
      }, props))
    );
  };
}

var _default = VideoProjectCard;
exports.default = _default;